import axios from 'axios';

const fetchData = (courseCode) => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/api/elearningdata/getdata`,
    {
      params: {
        courseCode
      }
    }
  );
}

const updateCoursePrepData = (data) => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/api/elearningdata/coursepreparationupdate`,
    data
  );
}

const completeCourse = (courseCode) => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/api/elearningdata/completecourse`,
    {
      courseCode
    }
  );
}

export const elearningService = {
  fetchData,
  updateCoursePrepData,
  completeCourse
}
